import React, { Component } from 'react'
import styled from 'styled-components'
import { H4 } from 'app/common/typography'
import { FormattedMessage } from 'react-intl'
import { CatalogStepper } from 'app/ecommerce/common/components/catalog'
import type { Menu, Product } from 'shared/store/ecommerce/catalog'
import type { PurchasableItem } from 'shared/store/ecommerce/order'
import { updateOrderSuggestions } from 'shared/utils/ecommerce/utils'
import { media } from 'app/assets/styles'

type Props = {
    currentItem?: Product | Menu,
    currentSuggestions: Array<PurchasableItem>,
    setCurrentSuggestions: (suggestions: Array<PurchasableItem>) => void,
    cartProducts: Array<PurchasableItem>
}

class CatalogStepperSuggestions extends Component<Props> {
    updateSuggestions = (quantity: number, id: string, suggestion: Product) => {
        const { setCurrentSuggestions, currentSuggestions } = this.props
        const updatedSuggestions = updateOrderSuggestions(
            currentSuggestions,
            id,
            suggestion,
            quantity
        )
        if (updatedSuggestions) {
            setCurrentSuggestions(updatedSuggestions)
        }
    }

    render() {
        const { currentItem, cartProducts } = this.props

        if (
            !currentItem ||
            !currentItem.suggestions ||
            currentItem.suggestions.length === 0
        ) {
            return null
        }
        const { suggestions } = currentItem
        const cartItemsMaxQuantityReached = cartProducts.filter(
            product => product.quantity === product.maxQuantity
        )
        const filteredSuggestions = suggestions.filter(
            suggestion =>
                suggestion &&
                !cartItemsMaxQuantityReached.find(
                    product => suggestion && product.id === suggestion.id
                ) &&
                !!suggestion.available
        )
        if (!filteredSuggestions || filteredSuggestions.length <= 0) {
            return null
        }
        return (
            <Container>
                <FormattedMessage id="clickandcollect.suggestions.title">
                    {(text: string) => <StyledH4>{text}</StyledH4>}
                </FormattedMessage>
                {filteredSuggestions.map((suggestion, index) => {
                    if (!suggestion) {
                        return null
                    }
                    const { id, name, image, price } = suggestion

                    let maxQuantity = suggestion.maxQuantity
                    const suggestionInCart = cartProducts.find(
                        product => product.id === suggestion.id
                    )
                    if (suggestionInCart) {
                        maxQuantity =
                            suggestionInCart.maxQuantity &&
                            suggestionInCart.maxQuantity -
                                suggestionInCart.quantity
                    }
                    return (
                        <CatalogStepper
                            key={index + id}
                            id={id}
                            name={name}
                            price={price}
                            imageUrl={image}
                            quantityInit={0}
                            onQuantityChange={(quantity: number) =>
                                this.updateSuggestions(quantity, id, suggestion)
                            }
                            quantityMax={maxQuantity}
                            noExtra
                        />
                    )
                })}
            </Container>
        )
    }
}

const StyledH4 = styled(H4)`
    margin-right: 20px;
    margin-left: 20px;
`

const Container = styled.div`
    width: 100%;
    margin-top: 20px;
    ${media.medium`
        margin-bottom: 40px;
    `};
`

export { CatalogStepperSuggestions }
